
import { RegisterClientPageView } from "./view";

export const RegisterClientPage = () => {
	return <RegisterClientPageView />;
};
